// import TextArea from "antd/es/input/TextArea";
// import axios from "axios";
// import React, { useState } from "react";
// import { Button, Card, Col } from "react-bootstrap";

// const Notification = () => {
//   const [notification, setNotification] = useState("");
//   const sendNotification = async () => {
//     const serverKey =
//       "AAAA7u8nv1Y:APA91bEO9n7rEH5TvVanyCjMW1UfVGqfuEtFUlL_ml1oiIGOAjUUqk8dLOSeRYPKH1p_uC6ObTPex0oSuw2YAPhlKuKJwG5E-zQuR-hdqvIvdyLoC9rrQJO9LXiHmXPEtHNDcB3O6DC3";
//     const fcmEndpoint = "https://fcm.googleapis.com/fcm/send";

//     const notificationData = {
//       to: "/topics/all",
//       notification: {
//         title: "forecastF1",
//         body: notification,
//       },
//     };

//     try {
//       const response = await axios.post(
//         fcmEndpoint,
//         JSON.stringify(notificationData),
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `key=${serverKey}`,
//           },
//         }
//       );
//       setNotification("");
//     } catch (error) {
//       console.error("Error sending notification:", error.message);
//     }
//   };

//   const handleChange = (e) => {
//     setNotification(e.target.value);
//   };
//   return (
//     <>
//       <div className="page-header2"></div>
//       <div className="row">
//         <Col sm={12} md={6} lg={6} xl={3}>
//           <Card className="custom-card">
//             <Card.Body>
//               <div className="card-order">
//                 <label className="main-content-label font-weight-bold mb-3 pt-1">
//                   Notification
//                 </label>
//                 <h2 className="text-end card-item-icon card-icon">
//                   <i className="fas fa-bell  icon-size float-start text-primary"></i>
//                 </h2>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//       </div>
//       <div className="row">
//         <Col sm={12} md={6} lg={6} xl={4}>
//           <Card className="custom-card">
//             <Card.Body>
//               <div className="card-order">
//                 <label className="main-content-label font-weight-bold mb-3 pt-1">
//                   Notification Text
//                 </label>
//                 <TextArea
//                   onChange={(e) => handleChange(e)}
//                   value={notification}
//                   style={{ minHeight: "100px" }}
//                 />
//                 <Button
//                   style={{ marginTop: "15px" }}
//                   onClick={sendNotification}
//                 >
//                   Send Notification
//                 </Button>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//       </div>
//     </>
//   );
// };

// export default Notification;

import TextArea from "antd/es/input/TextArea";
import axios from "axios";
import React, { useState } from "react";
import { Button, Card, Col, Spinner } from "react-bootstrap";
import ServiceJSON from "../../../forecast-f1.json";
import NotificationService from "../../services/notification.service";
import { useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";

const Notification = () => {
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();

  const { search } = location;
  const selectedType = search.split("=")[1];
  const [notification, setNotification] = useState("");
  const [notification2, setNotification2] = useState("");
  const [notification3, setNotification3] = useState("");
  const [commonNotificationLoading, setCommonNotificationLoading] =
    useState(false);
  const [individualNotificationLoading, setIndividualNotificationLoading] =
    useState("");

  const sendNotification = async () => {
    if (notification === "") {
      return enqueueSnackbar("Please Enter Notification Text", {
        variant: "error",
      });
    }
    try {
      setCommonNotificationLoading(true);
      const response = await NotificationService.SendCommonNotification(
        "forecastF1",
        notification
      );
      setNotification("");
      if (response.status === 200) {
        enqueueSnackbar("Notification Sent Successfully", {
          variant: "success",
        });
      }
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.message || "Something went wrong", {
        variant: "error",
      });
    } finally {
      setCommonNotificationLoading(false);
    }
  };

  const sendNotification2 = async (type) => {
    if (type === "F1" && notification2 === "") {
      return enqueueSnackbar("Please Enter Notification Text", {
        variant: "error",
      });
    }
    if (type === "MOTO_GP" && notification3 === "") {
      return enqueueSnackbar("Please Enter Notification Text", {
        variant: "error",
      });
    }
    try {
      setIndividualNotificationLoading(type);
      const response = await NotificationService.SendIndividualNotification(
        `forecast-${type}`,
        type === "F1" ? notification2 : notification3,
        type
      );
      if (response.status === 201) {
        if (type === "F1") {
          setNotification2("");
        } else {
          setNotification3("");
        }
        enqueueSnackbar(response?.data?.message || "Notification Sent Successfully", {
          variant: "success",
        });
      }
    } catch (error) {
      console.error("Error sending notification:", error.message);
      enqueueSnackbar(error?.response?.data?.message || "Something went wrong", {
        variant: "error",
      });
    } finally {
      setIndividualNotificationLoading("");
    }
  };

  const handleChange = (e) => {
    setNotification(e.target.value);
  };
  const handleChange2 = (e) => {
    setNotification2(e.target.value);
  };
  const handleChange3 = (e) => {
    setNotification3(e.target.value);
  };


  return (
    <>
      <div className="page-header2"></div>
      {selectedType === "common" && (
      <div className="row justify-content-start">
        <Col sm={12} md={8} lg={8} xl={6} className="">
          <Card className="custom-card">
            <Card.Body>
              <div className="card-order text-center">
                {/* <label className="main-content-label font-weight-bold mb-3 pt-1">
                  Notification
                </label> */}
                <div className="d-flex justify-content-start align-items-center gap-2">
                  <h2 className="card-item-icon card-icon">
                    <i className="fas fa-bell icon-size text-primary"></i>
                  </h2>
                  <label className="main-content-label font-weight-bold mb-3 pt-1">
                    Notification Text (COMMON)
                  </label>
                </div>
                <TextArea
                  onChange={handleChange}
                  value={notification}
                  style={{ minHeight: "160px", width: "100%" }}
                />
                <div className="text-center">
                  <Button
                    className="mt-3"
                    style={{ minWidth: "150px" }}
                    onClick={sendNotification}>
                    {commonNotificationLoading ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "Send Notification"
                    )}
                  </Button>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </div>
      )}
      {selectedType === "predict" && (
        <div className="row justify-content-start">
          <Col sm={12} md={6} lg={6} xl={6}>
            <Card className="custom-card mb-4">
              <Card.Body>
                <div className="card-order text-center">
                  <div className="d-flex justify-content-start align-items-center gap-2">
                    <h2 className="card-item-icon card-icon">
                      <i className="fas fa-bell icon-size text-primary"></i>
                    </h2>
                    <label className="main-content-label font-weight-bold mb-3 pt-1">
                      Notification For F1 Users
                    </label>
                  </div>
                </div>

                <div className="card-order mt-4">
                  <label className="main-content-label font-weight-bold mb-3 pt-1">
                    Notification Text Only Users without Prediction
                  </label>
                  <TextArea
                    onChange={handleChange2}
                    value={notification2}
                    style={{ minHeight: "160px", width: "100%" }}
                  />
                  <div className="text-center">
                    <Button
                      className="mt-3"
                      style={{ minWidth: "150px" }}
                      onClick={() => sendNotification2("F1")}>
                      {individualNotificationLoading === "F1" ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "Send Notification"
                      )}
                    </Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col sm={12} md={6} lg={6} xl={6}>
            <Card className="custom-card mb-4">
              <Card.Body>
                <div className="card-order text-center">
                  <div className="d-flex justify-content-start align-items-center gap-2">
                    <h2 className="card-item-icon card-icon">
                      <i className="fas fa-bell icon-size text-primary"></i>
                    </h2>
                    <label className="main-content-label font-weight-bold mb-3 pt-1">
                      Notification For MotoGP Users
                    </label>
                  </div>
                </div>

                  <div className="card-order mt-4">
                    <label className="main-content-label font-weight-bold mb-3 pt-1">
                      Notification Text Only Users without Prediction
                    </label>
                    <TextArea
                      onChange={handleChange3}
                      value={notification3}
                      style={{ minHeight: "160px", width: "100%" }}
                    />
                    <div className="text-center">
                      <Button
                        className="mt-3"
                        style={{ minWidth: "150px" }}
                        onClick={() => sendNotification2("MOTO_GP")}>
                        {individualNotificationLoading == "MOTO_GP" ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            className="text-white"
                          />
                        ) : (
                          "Send Notification"
                        )}
                      </Button>
                    </div>
                  </div>
              </Card.Body>
            </Card>
          </Col>
        </div>
      )}

    </>
  );
};

export default Notification;
